import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import filter from 'lodash/filter';
import map from 'lodash/map';

export const Filter = {
  ALL: 'all',
  VIDEO: 'video',
  IMAGE: 'image',
  LINK: 'url',
};

export const tabList = (t) => [
  { key: Filter.ALL, tab: t('filter-everything') },
  { key: Filter.VIDEO, tab: t('filter-video') },
  { key: Filter.IMAGE, tab: t('filter-image') },
  { key: Filter.LINK, tab: t('filter-link') },
];

const useFilterContentByType = ({ content }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(Filter.ALL);

  const filterContent = useMemo(() => {
    const filteredContent =
      activeTab === Filter.ALL
        ? content
        : filter(content, ({ type }) => type === activeTab);
    return map(filteredContent, ({ url, ...rest }) => ({
      ...rest,
      url: url,
    }));
  }, [content, activeTab]);

  const lightboxImages = useMemo(
    () => filter(content, ({ type }) => type !== 'url'),
    [content]
  );

  const tabs = useMemo(() => {
    return tabList(t);
  }, [t]);

  const onChange = useCallback((tabId) => setActiveTab(tabId), []);

  return {
    t,
    activeTab,
    content: filterContent,
    lightboxImages,
    onChange,
    tabList: tabs,
    Filter,
  };
};

export default useFilterContentByType;
